import { createApp } from 'vue'
import EuroConverter from './EuroConverter.vue'
import './assets/global.css'

createApp(EuroConverter).mount('#euro')
